import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-carbon" data-id="element-85" data-mp="bjw7e2yctbx8">
      <div className="max-w-6xl mx-auto" data-id="element-86" data-mp="bi1lalbcjdrk">
        <div className="text-center mb-16" data-id="element-87" data-mp="gbec923hzwnh">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white" data-id="element-88" data-mp="gc5tf7wclru8">
            What BJJ instructors who already have the{' '}
            <span className="text-gold" data-id="element-89" data-mp="q8sdhuguoev7">complete system</span> say
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-90" data-mp="uama9rnxcyq3">
          {extendedTestimonials.map((testimonial, index) => <motion.figure key={testimonial.initials} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className={`bg-carbon-graphite border border-gold/20 p-8 rounded-2xl relative flex flex-col ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-91" data-mp="z8nuifx37435" data-mpi={index}>
              <QuoteIcon className="absolute top-6 right-6 text-gold/15" size={48} aria-hidden="true" data-id="element-92" data-mp="33ykrhdh75rrv" />
              <div className="flex gap-1 text-gold mb-6" aria-label="5 out of 5 stars" data-id="element-93" data-mp="2z09it62n1nb8">
                {[...Array(5)].map((_, star) => <StarIcon key={star} size={16} fill="currentColor" data-id="element-94" data-mp="3vpgvrpp6yo3j" data-mpi={star} />)}
              </div>
              <blockquote className="text-mist italic mb-8 relative z-10 leading-relaxed" data-id="element-95" data-mp="3rp6o88lr3pmk">
                &quot;{testimonial.text}&quot;
              </blockquote>
              <figcaption className="flex items-center gap-4 mt-auto" data-id="element-96" data-mp="3hr0re5esx9ok">
                <div className="w-12 h-12 rounded-full border border-gold flex items-center justify-center text-gold font-bold text-lg" data-id="element-97" data-mp="2b9vplc8bhif2">
                  {testimonial.initials}
                </div>
                <div data-id="element-98" data-mp="27shf6gu9rl0m">
                  <div className="font-bold text-white" data-id="element-99" data-mp="27rzmfu6tfoxg">{testimonial.name}</div>
                  <div className="text-xs text-smoke" data-id="element-100" data-mp="2cr2jarcn6ouc">{testimonial.role}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}